// export default {
//     namespaced: true,
//     state: {
//       tabIndex: 0
//     },
//     getters: {
//       getTabIndex(state) {
//         return state.tabIndex;
//       }
//     },
//     mutations: {
//       setTabIndex(state, newIndex) {
//         state.tabIndex = newIndex;
//       }
//     },
//     actions: {
//       setTabIndex(context, newIndex) {
//         context.commit('setTabIndex', newIndex);
//       }
//     }
//   }
  
import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')


export const state = {
    tabIndex:0,
    searchHome:''
}

export const getters = {
    getTabIndex(state) {
      return state.tabIndex
    },
    getSearchHome(state) {
      return state.searchHome
    }
  }
  

export const mutations = {
    setTabIndex(state, newIndex) {
        state.tabIndex = newIndex
        },
    setSearchHome(state, newSearchHome) {
        state.searchHome = newSearchHome
        }
}

export const actions = {

  init({ state, dispatch }) {},
  setTabIndex(context, newIndex) {
      context.commit('setTabIndex', newIndex);
  },
  setSearchHome(context, newSearchHome) {
      context.commit('setSearchHome', newSearchHome);
  }
}
